import { useQuery } from "react-query";
import { locationMenuService } from "../services";

interface IGetFavoriteLocationPayload {
  favorites_only: boolean;
  user_id: number;
  enable?: boolean
}

const getFavoriteLocations = async (data: IGetFavoriteLocationPayload) => {
  const response = await locationMenuService.getNearbyLocations(data);
  return response.data.data;
};

export default function useGetFavoriteLocations(
  customerId: number,
  isGuestUser: boolean,
  enable?: boolean
) {
  const payload: IGetFavoriteLocationPayload = {
    favorites_only: true,
    user_id: customerId,
    enable: true
  };
  return useQuery(
    ["getFavoriteLocations", customerId, isGuestUser],
    () => getFavoriteLocations(payload),
    {
      // Guests use the same nearest/list + user_id path as loyalty.
      enabled: !!customerId && !!enable,
    }
  );
}
